import { get, patch, post } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';
import { DevicesService } from '@/services/devices.service';

export default {
  getItemsList({ commit }, { params } = {}) {
    return DevicesService.getList({
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  }
};
